module.exports = __webpack_public_path__ + "media/images/logo_air_canada-6d750b6fc896bb260fd52ddb94ba0266.png";